'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _lowercaseKeys = require('lowercase-keys');

var _lowercaseKeys2 = _interopRequireDefault(_lowercaseKeys);

var _extractParams = require('extract-params');

var _lodashPick = require('lodash.pick');

var _lodashPick2 = _interopRequireDefault(_lodashPick);

var _cleanUrls = require('./clean-urls');

var _cleanUrls2 = _interopRequireDefault(_cleanUrls);

var _hierarchySlugs = require('./hierarchy/slugs');

var _expandQuery = require('./expand-query');

var _expandQuery2 = _interopRequireDefault(_expandQuery);

var _constants = require('./constants');

var paramValueRegex = /^[^/]+$/;

var searchParamKeys = Object.keys(_constants.SEARCH_PARAMS);

function whitelistSearchQuery(query) {
  return _lodashPick2['default'].apply(undefined, [query].concat(_toConsumableArray(searchParamKeys)));
}

function removeEmptyQueryKeys(query) {
  var result = {};

  for (var key in query) {
    if (query[key] !== '') {
      result[key] = query[key];
    }
  }

  return result;
}

function transform(params) {
  var allValid = Object.keys(params).every(function (param) {
    var value = params[param];

    return (0, _hierarchySlugs.getIdBySlug)(param, value) !== null && paramValueRegex.test(value);
  });

  return allValid ? params : null;
}

var extractParamsPatterns = _cleanUrls2['default'].map(function (cleanUrl) {
  return {
    pattern: cleanUrl,
    caseSensitive: false,
    transform: transform
  };
});

exports['default'] = function (_ref) {
  var path = _ref.path;
  var query = _ref.query;

  var cleanPath = path.replace(/(.)\/$/, '$1'); // Remove trailing slash for paths other than '/'
  var cleanQuery = (0, _expandQuery2['default'])(removeEmptyQueryKeys((0, _lowercaseKeys2['default'])(query)));
  var extractedParams = (0, _extractParams.extractParamsInFirstMatch)(cleanPath, extractParamsPatterns);
  var usedParams = extractedParams === null ? {} : (0, _hierarchySlugs.convertSlugsToIds)(extractedParams.params);

  return whitelistSearchQuery(_extends({}, cleanQuery, usedParams));
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/normalise-search-query.js
 ** module id = 524
 ** module chunks = 0
 **/